// i18n — IKKI QATLAMNING IKKINCHISI (07-FRONTEND.md §5).
//
// antd komponentlari o'z matnlarini `ConfigProvider locale` dan oladi:
// jadvaldagi "Ma'lumot yo'q", `Popconfirm` dagi "OK / Bekor qilish",
// `DatePicker` dagi oy nomlari va hafta boshi.
//
// Buni o'rnatmasak i18next hammasini tarjima qilgandek ko'rinadi, lekin
// o'zbekcha panelda bo'sh jadval tagida inglizcha "No data" turadi — va bu
// aynan foydalanuvchi eng ko'p qaraydigan joy.

import type { Locale } from 'antd/es/locale'
import enUS from 'antd/locale/en_US'
// antd'da dariy locale yo'q — `fa_IR` ishlatiladi. Ichki matnlar
// (OK, Bekor qilish, oy nomlari) ikkala shevada ham bir xil.
import faIR from 'antd/locale/fa_IR'
import ruRU from 'antd/locale/ru_RU'
import uzUZ from 'antd/locale/uz_UZ'
import type { Language } from './index'

export const ANTD_LOCALES: Record<Language, Locale> = {
  en: enUS,
  fa: faIR,
  ru: ruRU,
  uz: uzUZ,
}
